import script from "./DayModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DayModal.vue?vue&type=script&lang=ts&setup=true"

import "./DayModal.vue?vue&type=style&index=0&id=08747648&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08747648"]])

export default __exports__